var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.eventCrops)?_c('div',{staticClass:"crops d-flex"},_vm._l((_vm.crops),function(crop,index){return _c('div',{key:index,staticClass:"crop",class:{ 'crop-big': _vm.isBig }},[_c('span',{class:['icon', crop.icon]})])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }